var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3838 16H1.61616C0.727273 16 0 15.2461 0 14.3246V1.67539C0 0.753927 0.727273 0 1.61616 0H14.3838C15.2727 0 16 0.753927 16 1.67539V14.3246C16 15.2461 15.2727 16 14.3838 16ZM1.61616 0.837696C1.21212 0.837696 0.808081 1.25654 0.808081 1.67539V14.3246C0.808081 14.8272 1.21212 15.1623 1.61616 15.1623H14.3838C14.8687 15.1623 15.1919 14.7435 15.1919 14.3246V1.67539C15.1919 1.17277 14.7879 0.837696 14.3838 0.837696H1.61616Z",
    fill: "#6D7781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1919 0H0V0.837697H15.1919V0Z",
    fill: "#6D7781",
    transform: "translate(0.403 2.346)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69697 0.837695H0.40404C0.161616 0.837695 0 0.670156 0 0.418847C0 0.167538 0.161616 0 0.40404 0H9.69697C9.93939 0 10.101 0.167538 10.101 0.418847C10.101 0.670156 9.93939 0.837695 9.69697 0.837695Z",
    fill: "#6D7781",
    transform: "translate(2.909 13.235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.404041 7.70681C0.161617 7.70681 0 7.53927 0 7.28796V0.418848C0 0.167539 0.161617 0 0.404041 0C0.646466 0 0.808083 0.167539 0.808083 0.418848V7.28796C0.808083 7.53927 0.646466 7.70681 0.404041 7.70681Z",
    fill: "#6D7781",
    transform: "translate(11.152 4.440)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.404041 6.03141C0.161616 6.03141 0 5.86387 0 5.61257V0.418848C0 0.167539 0.161616 0 0.404041 0C0.646466 0 0.808082 0.167539 0.808082 0.418848V5.61257C0.808082 5.86387 0.646466 6.03141 0.404041 6.03141Z",
    fill: "#6D7781",
    transform: "translate(7.597 6.115)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40404 4.35602C0.161616 4.35602 0 4.18848 0 3.93717V0.418848C0 0.167539 0.161616 0 0.40404 0C0.646465 0 0.808081 0.167539 0.808081 0.418848V3.93717C0.808081 4.18848 0.565656 4.35602 0.40404 4.35602Z",
    fill: "#6D7781",
    transform: "translate(4.040 7.790)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/settlement.cbeb330c.svg";
export { ForwardRef as ReactComponent };